import { render, staticRenderFns } from "./TaskSettings.vue?vue&type=template&id=7f349cfe&scoped=true&"
import script from "./TaskSettings.vue?vue&type=script&lang=js&"
export * from "./TaskSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f349cfe",
  null
  
)

export default component.exports